<div class="modal-header">
  <h5 class="modal-title">App Lock</h5>
  <button type="button"
          class="btn-close"
          aria-label="Close"
          (click)="modal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
  <ml-mdm-command-spinner [commandProgress]="commandProgress$">
    <h5>{{ app.name }}</h5>
    <h6>{{ app.identifier }}</h6>
    <form [formGroup]="appLockForm"
          (ngSubmit)="onSubmit()">
      <div id="app-lock-options">
        <div class="item">
          <a (click)="showOptions = !showOptions">
            <span [hidden]="showOptions">Show options
              <fa-icon icon="chevron-down"></fa-icon>
            </span>
            <span [hidden]="!showOptions">Hide options
              <fa-icon icon="chevron-up"></fa-icon>
            </span>
          </a>
          <div [hidden]="!showOptions"
               class="mt-2">
            <div>
              <div class="form-check">
                <label class="form-check-label">
                  <input class="form-check-input"
                         type="checkbox"
                         aria-describedby="disableTouchHelp"
                         formControlName="disableTouch" />
                  Disable touch
                </label>
                <small id="disableTouchHelp"
                       class="form-text text-muted">
                  If true, the touch screen is disabled. Default is false. Available in tvOS 10.2 and later.
                </small>
              </div>
            </div>

            <div>
              <div class="form-check">
                <label class="form-check-label">
                  <input class="form-check-input"
                         type="checkbox"
                         aria-describedby="disableDeviceRotationHelp"
                         formControlName="disableDeviceRotation" />
                  Disable device rotation
                </label>
                <small id="disableDeviceRotationHelp"
                       class="form-text text-muted">
                  If true, device rotation sensing is disabled. Default is false.
                </small>
              </div>
            </div>

            <div>
              <div class="form-check">
                <label class="form-check-label">
                  <input class="form-check-input"
                         type="checkbox"
                         aria-describedby="disableVolumeButtonsHelp"
                         formControlName="disableVolumeButtons" />
                  Disable volume buttons
                </label>
                <small id="disableVolumeButtonsHelp"
                       class="form-text text-muted">
                  If true, the volume buttons are disabled. Default to false.
                </small>
              </div>
            </div>

            <div>
              <div class="form-check">
                <label class="form-check-label">
                  <input class="form-check-input"
                         type="checkbox"
                         aria-describedby="disableRingerSwitchHelp"
                         formControlName="disableRingerSwitch" />
                  Disable ringer switch
                </label>
                <small id="disableRingerSwitchHelp"
                       class="form-text text-muted">
                  If true, the ringer switch is disabled. Default is false. When disabled, the ringer behavior depends
                  on what position the switch was in when it was first disabled.
                </small>
              </div>
            </div>

            <div>
              <div class="form-check">
                <label class="form-check-label">
                  <input class="form-check-input"
                         type="checkbox"
                         aria-describedby="disableSleepWakeButtonHelp"
                         formControlName="disableSleepWakeButton" />
                  Disable sleep/wake button
                </label>
                <small id="disableSleepWakeButtonHelp"
                       class="form-text text-muted">
                  If true, the sleep/wake button is disabled. Default is false.
                </small>
              </div>
            </div>

            <div>
              <div class="form-check">
                <label class="form-check-label">
                  <input class="form-check-input"
                         type="checkbox"
                         aria-describedby="disableAutoLockHelp"
                         formControlName="disableAutoLock" />
                  Disable auto lock
                </label>
                <small id="disableAutoLockHelp"
                       class="form-text text-muted">
                  If true, the device will not automatically go to sleep after an idle period. Available in tvOS 10.2
                  and later.
                </small>
              </div>
            </div>

            <div>
              <div class="form-check">
                <label class="form-check-label">
                  <input class="form-check-input"
                         type="checkbox"
                         aria-describedby="enableVoiceOverHelp"
                         formControlName="enableVoiceOver" />
                  Enable voice over
                </label>
                <small id="enableVoiceOverHelp"
                       class="form-text text-muted">
                  If true, VoiceOver is turned on. Default is false. Available in tvOS 10.2 and later.
                </small>
              </div>
            </div>

            <div>
              <div class="form-check">
                <label class="form-check-label">
                  <input class="form-check-input"
                         type="checkbox"
                         aria-describedby="enableZoomHelp"
                         formControlName="enableZoom" />
                  Enable zoom
                </label>
                <small id="enableZoomHelp"
                       class="form-text text-muted">
                  If true, Zoom is turned on. Default is false. Available in tvOS 10.2 and later.
                </small>
              </div>
            </div>

            <div>
              <div class="form-check">
                <label class="form-check-label">
                  <input class="form-check-input"
                         type="checkbox"
                         aria-describedby="enableInvertColorsHelp"
                         formControlName="enableInvertColors" />
                  Enable invert colors
                </label>
                <small id="enableInvertColorsHelp"
                       class="form-text text-muted">
                  If true, Invert Colors is turned on. Default is false. Available in tvOS 10.2 and later.
                </small>
              </div>
            </div>

            <div>
              <div class="form-check">
                <label class="form-check-label">
                  <input class="form-check-input"
                         type="checkbox"
                         aria-describedby="enableAssistiveTouchHelp"
                         formControlName="enableAssistiveTouch" />
                  Enable Assistive Touch
                </label>
                <small id="enableAssistiveTouchHelp"
                       class="form-text text-muted">
                  If true, AssistiveTouch is turned on. Default is false.
                </small>
              </div>
            </div>

            <div>
              <div class="form-check">
                <label class="form-check-label">
                  <input class="form-check-input"
                         type="checkbox"
                         aria-describedby="enableSpeakSelectionHelp"
                         formControlName="enableSpeakSelection" />
                  Enable speak selection
                </label>
                <small id="enableSpeakSelectionHelp"
                       class="form-text text-muted">
                  If true, Speak Selection is turned on. Default is false.
                </small>
              </div>
            </div>

            <div>
              <div class="form-check">
                <label class="form-check-label">
                  <input class="form-check-input"
                         type="checkbox"
                         aria-describedby="enableMonoAudioHelp"
                         formControlName="enableMonoAudio" />
                  Enable mono audio
                </label>
                <small id="enableMonoAudioHelp"
                       class="form-text text-muted">
                  If true, Mono Audio is turned on. Default is false.
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div class="item">
          <a (click)="showUserOptions = !showUserOptions">
            <span [hidden]="showUserOptions">Show user options
              <fa-icon icon="chevron-down"></fa-icon>
            </span>
            <span [hidden]="!showUserOptions">Hide user options
              <fa-icon icon="chevron-up"></fa-icon>
            </span>
          </a>
          <div [hidden]="!showUserOptions"
               class="mt-2"
               role="tabpanel">
            <div>
              <div class="form-check">
                <label class="form-check-label">
                  <input class="form-check-input"
                         type="checkbox"
                         aria-describedby="voiceOverHelp"
                         formControlName="voiceOver" />
                  Voice over
                </label>
                <small id="voiceOverHelp"
                       class="form-text text-muted">
                  If true, allow Voice Over adjustment. Default is false.
                </small>
              </div>
            </div>

            <div>
              <div class="form-check">
                <label class="form-check-label">
                  <input class="form-check-input"
                         type="checkbox"
                         aria-describedby="zoomHelp"
                         formControlName="zoom" />
                  Zoom
                </label>
                <small id="zoomHelp"
                       class="form-text text-muted">
                  If true, allow Zoom adjustment. Default is false.
                </small>
              </div>
            </div>

            <div>
              <div class="form-check">
                <label class="form-check-label">
                  <input class="form-check-input"
                         type="checkbox"
                         aria-describedby="invertColorsHelp"
                         formControlName="invertColors" />
                  Invert colors
                </label>
                <small id="invertColorsHelp"
                       class="form-text text-muted">
                  If true, allow Invert Colors adjustment. Default is false.
                </small>
              </div>
            </div>

            <div>
              <div class="form-check">
                <label class="form-check-label">
                  <input class="form-check-input"
                         type="checkbox"
                         aria-describedby="assistiveTouchHelp"
                         formControlName="assistiveTouch" />
                  Assistive touch
                </label>
                <small id="assistiveTouchHelp"
                       class="form-text text-muted">
                  If true, allow Assistive Touch adjustment. Default is false.
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </ml-mdm-command-spinner>
</div>
<div class="modal-footer">
  <ml-mdm-command-spinner [commandProgress]="commandProgress$"
                          [small]="true"
                          [reverse]="true"
                          [direction]="'right'">
    <button ngbAutofocus
            type="submit"
            class="btn btn-primary align-self-end"
            (click)="onSubmit()">
      <fa-icon icon="lock"></fa-icon>
      <span class="ms-2"
            i18n>Lock</span>
    </button>
  </ml-mdm-command-spinner>
</div>